import { useContext, useEffect, useState } from "react";
import "../../../../styles/Widgets/Buttons/EditStateNavigationButtonWidget.css";
import { AppContext } from "../../../AppProvider";
import { DashboardContext } from "../../../workspace_components/TenantAdministratorComponents/Dashboards/DashboardProvider";
const EditStateNavigationButtonWidget = () =>{const [targetDashboardStateFilterString,setTargetDashboardStateFilterString] = useState('');
    const {
        dashboard,activeDashboardState,
        activeEditWidget,setActiveEditWidget
    } = useContext(DashboardContext);
    const [selectedTargetDashboardState,setSelectedTargetDashboardState] = useState(null);
    const [showDashboardStatesBrowser,setShowDashboardStatesBrowser] = useState(false);
    const [iconPreview,setIconPreview] = useState(null);
    const [iconPreviewPrefix,setIconPreviewPrefix] = useState(null);
    const [iconName,setIconName] = useState(null);
    const [iconSize,setIconSize] = useState(null);
    const [iconBorderRadius,setIconBorderRadius] = useState(0);
    const [text,setText] = useState('');
    const [textColor,setTextColor] = useState('#000000');
    const [iconToTextRatio,setIconToTextRatio] = useState(50);
    const [toolTip,setToolTip] = useState('');
    const [cursorFilterString,setCursorFilterString] = useState('');
    const [selectedCursor,setSelectedCursor] = useState('POINTER');
    const [showCursorsBrowser,setShowCursorsBrowser] = useState(false);
    const [borderRadius,setBorderRadius] = useState(0);
    const [mobileHeightFactor,setMobileHeightFactor] = useState(5);
    const [changesAvailable,setChangesAvailable] = useState(false);
    const cursors = ["DEFAULT","POINTER","HELP"];
    const allowedImageExtensions = ["png","jpg","jpeg"];
    const maxImageSize = 5 * 1024 * 1024;
    const validTargetDashboardState = selectedTargetDashboardState?.id;
    const validText = text?.length> 0 && text?.length < 255;
    const validToolTip = toolTip?.length < 255;
    const validCursor = selectedCursor;
    const validEntries = validTargetDashboardState && validText && validToolTip && validCursor;
    const hexToRgb = (hex) => {
        hex = hex.replace('#', '');
        const r = parseInt(hex.substring(0, 2), 16);
        const g = parseInt(hex.substring(2, 4), 16);
        const b = parseInt(hex.substring(4, 6), 16);

        return `rgb(${r}, ${g}, ${b})`;
    };
    const getBrightness = (hex) => {
        hex = hex.replace('#', '');
        const r = parseInt(hex.substring(0, 2), 16);
        const g = parseInt(hex.substring(2, 4), 16);
        const b = parseInt(hex.substring(4, 6), 16);
        return (0.2126 * r + 0.7152 * g + 0.0722 * b);
    };
    const uploadImage = (e) =>{
        const file = e.target.files[0];
        if(!file) return;
        const extension = file?.name?.split(".").pop().toLowerCase();
        if(!allowedImageExtensions.includes(extension)){
            window.alert("Only PNG or JPG images are allowed");
            return;
        }
        if(file?.size > maxImageSize){
            window.alert("File must be 5MB or smaller");
            return;
        }
        const reader = new FileReader();
        reader.onloadend = () =>{
            setIconPreview(reader.result.split(",")[1]);
            setIconPreviewPrefix(reader.result.split(",")[0]);
        }
        reader.readAsDataURL(file);
        setIconName(file?.name);
        setIconSize(file?.size);
    };
    const formatCursorForDisplay = (cursor) =>{
        if (!cursor) return "";
        cursor = cursor.replace(/_/g,' ');
        return cursor.charAt(0).toUpperCase() + cursor.slice(1).toLowerCase();
    };
    const loadActiveWidget = () =>{
        setSelectedTargetDashboardState(dashboard?.dashboardStates?.find(dashboardState => dashboardState?.id === activeEditWidget?.config?.targetDashboardStateId));
        setIconPreview(activeEditWidget?.config?.icon?.image || null);
        setIconPreviewPrefix(activeEditWidget?.config?.icon?.imagePrefix || null);
        setIconName(activeEditWidget?.config?.icon?.name || null);
        setIconSize(activeEditWidget?.config?.icon?.size || null);
        setIconBorderRadius(activeEditWidget?.config?.icon?.borderRadius || 0);
        setText(activeEditWidget?.config?.text || '');
        setTextColor(activeEditWidget?.config?.textColor);
        setIconToTextRatio(activeEditWidget?.config?.iconToTextRatio);
        setToolTip(activeEditWidget?.config?.toolTip);
        setSelectedCursor(activeEditWidget?.config?.cursor);
        setBorderRadius(activeEditWidget?.borderRadius);
        setMobileHeightFactor(activeEditWidget?.mobileHeightFactor);
    };
    const checkChanges = () =>{
        if(
            selectedTargetDashboardState?.id !== activeEditWidget?.config?.targetDashboardStateId ||
            iconPreview !== activeEditWidget?.config?.icon?.image ||
            iconPreviewPrefix !== activeEditWidget?.config?.icon?.imagePrefix ||
            iconName !== activeEditWidget?.config?.icon?.name ||
            iconSize !== activeEditWidget?.config?.icon?.size ||
            iconBorderRadius !== activeEditWidget?.config?.icon?.borderRadius ||
            text !== activeEditWidget?.config?.text ||
            textColor !== activeEditWidget?.config?.textColor ||
            iconToTextRatio !== activeEditWidget?.config?.iconToTextRatio ||
            toolTip !== activeEditWidget?.config?.toolTip ||
            selectedCursor !== activeEditWidget?.config?.cursor ||
            borderRadius !== activeEditWidget?.borderRadius ||
            mobileHeightFactor !== activeEditWidget?.mobileHeightFactor
        ) setChangesAvailable(true);
        else setChangesAvailable(false);
    };
    const setUpdatedWidget = () =>{
        const updatedStateNavigationButton = activeEditWidget;
        updatedStateNavigationButton.config = {
            targetDashboardStateId:selectedTargetDashboardState?.id,
            text:text,
            textColor:textColor,
            iconToTextRatio:iconToTextRatio,
            toolTip:toolTip,
            cursor:selectedCursor,
            icon: !iconPreview || !iconPreviewPrefix || !iconName || !iconSize? null:{
                image:iconPreview,
                imagePrefix:iconPreviewPrefix,
                name:iconName,
                size:iconSize,
                borderRadius:iconBorderRadius
            }
    };
        updatedStateNavigationButton.borderRadius = borderRadius;
        updatedStateNavigationButton.mobileHeightFactor = mobileHeightFactor;
        return updatedStateNavigationButton;
    };
    const resetEditStateNavigationButtonWidgetWindow =  () =>{
        setTargetDashboardStateFilterString('');
        setSelectedTargetDashboardState(null);
        setShowDashboardStatesBrowser(false);
        setIconPreview(null);
        setIconPreviewPrefix(null);
        setIconName(null);
        setIconSize(null);
        setIconBorderRadius(0);
        setText('');
        setTextColor('#000000');
        setIconToTextRatio(50);
        setToolTip('');
        setCursorFilterString('');
        setSelectedCursor('POINTER');
        setShowCursorsBrowser(false);
        setBorderRadius(0);
        setMobileHeightFactor(5);
    };
    const disposeWindow = () =>{
        resetEditStateNavigationButtonWidgetWindow();
        setActiveEditWidget(null);
    };
    const updateWidget = () =>{
        setUpdatedWidget();
        disposeWindow();
    };
    useEffect(() => {
        if(activeEditWidget && activeEditWidget?.type === 'state_navigation_button'){
            loadActiveWidget();
        }
    },[activeEditWidget]);
    useEffect(() =>{
        checkChanges();
    },[
        selectedTargetDashboardState,
        iconPreview,
        iconPreviewPrefix,
        iconName,
        iconSize,
        iconBorderRadius,
        text,
        textColor,
        iconToTextRatio,
        toolTip,
        selectedCursor,
        borderRadius,
        mobileHeightFactor
    ]);
    return(
        <div className="edit-state-navigation-button-widget-container">
            <div className="edit-state-navigation-button-widget-header-container">
                <div className="edit-state-navigation-button-main-header-container">
                    <div>
                        <h2>{text}</h2>
                        <p>State navigation button</p>
                    </div>
                    <div>
                        <button
                            className="help-button"
                            title="Go to help page">?
                        </button>
                        <button
                            className="close-editor-button"
                            onClick={() => disposeWindow()}
                            title="Close the editor">&#10006;
                        </button>
                    </div>
                </div>
                <div className="edit-state-navigation-button-minor-header-container">
                    <div>
                        <button
                            className={changesAvailable? 'decline active':'decline inactive'}
                            onClick={() => disposeWindow()}>&#10006; Decline
                        </button>
                        <button
                            className={changesAvailable? 'apply active':'apply inactive'}
                            onClick={() => updateWidget()}>&#10003; Apply</button>
                    </div>
                </div>
            </div>
            <div className="edit-state-navigation-button-widget-body-container">
                <div className="edit-state-navigation-button-widget-link-container">
                        <div className="header">
                            <h2>Link</h2>
                        </div>
                        <div className="body">
                            <div className="target-dashboard-state-selection-container">
                                <p>Target dashboard state<span>*</span></p>
                                <div className="target-dashboard-state-entry-container">
                                    <input
                                        placeholder="Select the target dashboard state"
                                        readOnly={selectedTargetDashboardState}
                                        style={{cursor:selectedTargetDashboardState? 'pointer':'text'}}
                                        value={selectedTargetDashboardState? selectedTargetDashboardState?.name:targetDashboardStateFilterString}
                                        onChange={(e) => setTargetDashboardStateFilterString(e.target.value)}
                                        onFocus={() => setShowDashboardStatesBrowser(true)}
                                        onBlur={() =>{
                                            setTimeout(() =>{setShowDashboardStatesBrowser(false);},250);
                                        }}
                                    />
                                    <p
                                        style={{display:selectedTargetDashboardState? 'flex':'none'}}
                                        title="Remove selected target dashboard state"
                                        onClick={() =>{
                                            setTargetDashboardStateFilterString('');
                                            setSelectedTargetDashboardState(null);
                                        }}>&#10006;
                                    </p>
                                </div>
                                <div className={`dashboard-states-browser ${showDashboardStatesBrowser? 'active':''}`}>
                                    {dashboard?.dashboardStates && dashboard?.dashboardStates.filter(dashboardState => dashboardState?.id !== activeDashboardState?.id)
                                    .filter(dashboardState => dashboardState?.name?.toLowerCase()?.includes(targetDashboardStateFilterString?.toLowerCase()))
                                    .sort((a,b) => a?.name.localeCompare(b?.name)).map((dashboardState) => (
                                        <div key={dashboardState?.id} onClick={() => setSelectedTargetDashboardState(dashboardState)}>
                                            {dashboardState?.name}
                                        </div>
                                    ))}
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className="edit-state-navigation-button-widget-appearance-container">
                        <div className="header">
                            <h2>Appearance</h2>
                        </div>
                        <div className="body">
                            <div className="icon-container">
                                <p>Icon</p>
                                <div className="icon-details-container">
                                    <div className="icon-image-picture-container">
                                        <img
                                            alt="icon preview"
                                            style={{borderRadius:`${iconBorderRadius}%`}}
                                            src={`${iconPreviewPrefix},${iconPreview}`}
                                        />
                                    </div>
                                    <div className="icon-image-meta-data-container">
                                        <p className="image-name-p">{iconName}</p>
                                        <div>
                                            <button className="upload-button" onClick={() => document.getElementById('new-state-navigation-button-widget-icon-input').click()}>Upload icon</button>
                                            <button className="delete-button" onClick={() => {
                                                setIconPreview(null);
                                                setIconPreviewPrefix(null);
                                                setIconName(null);
                                            }}>Delete icon</button>
                                        </div>
                                    </div>
                                </div>
                                <input
                                    id="new-state-navigation-button-widget-icon-input"
                                    type="file"
                                    accept={allowedImageExtensions.map(ext => `.${ext}`).join(",")}
                                    style={{display:"none"}}
                                    onChange={(e) => uploadImage(e)}
                                />
                            </div>
                            <div className="icon-border-radius-container">
                                <p>Icon border radius</p>
                                <div>
                                    <p>{iconBorderRadius}%</p>
                                    <input
                                        type="range"
                                        min={0}
                                        max={100}
                                        step={1}
                                        value={iconBorderRadius}
                                        onChange={(e) => setIconBorderRadius(Number(e.target.value) || 0)}
                                    />
                                </div>
                            </div>
                            <div className="text-entry-container">
                                <p>Text</p>
                                <input value={text} maxLength={255} onChange={(e) => setText(e.target.value)}/>
                            </div>
                            <div className="text-color-container">
                                <p>Text color</p>
                                <div>
                                    <p style={{
                                        color:textColor,
                                        textShadow: getBrightness(textColor) > 180? '1px 1px 1px rgba(0,0,0,1)':'none'
                                    }}>{hexToRgb(textColor)}</p>
                                    <input
                                        type="color"
                                        title="Select color"
                                        value={textColor}
                                        onChange={(e) => setTextColor(e.target.value)}
                                    />
                                </div>
                            </div>
                            <div className="icon-text-ratio-container">
                                <p>Icon to text ratio</p>
                                <div>
                                    <p>{iconToTextRatio}%</p>
                                    <input
                                        type="range"
                                        min={0}
                                        max={100}
                                        step={1}
                                        value={iconToTextRatio}
                                        onChange={(e) => setIconToTextRatio(Number(e.target.value))}
                                    />
                                </div>
                            </div>
                            <div className="tool-tip-container">
                                <p>Tooltip</p>
                                <input value={toolTip} maxLength={255} onChange={(e) => setToolTip(e.target.value)}/>
                            </div>
                            <div className="cursor-selection-container">
                                <p>Cursor <span>*</span></p>
                                <div className="cursor-entry-container">
                                    <input
                                        value={selectedCursor? formatCursorForDisplay(selectedCursor):cursorFilterString}
                                        readOnly={selectedCursor}
                                        style={{cursor:selectedCursor? 'pointer':'text'}}
                                        onChange={(e) => setCursorFilterString(e.target.value)}
                                        onFocus={() => setShowCursorsBrowser(true)}
                                        onBlur={() => setTimeout(() =>{
                                            setShowCursorsBrowser(false);
                                        },250)}
                                    />
                                    <p title="Remove selected cursor"
                                        style={{display:selectedCursor? 'flex':'none'}}
                                        onClick={() => {
                                            setCursorFilterString('');
                                            setSelectedCursor(null);
                                        }}>&#10006;
                                    </p>
                                </div>
                                <div className={`cursors-browser ${showCursorsBrowser? 'active':''}`}>
                                    {cursors?.filter(cursor => cursor?.toLowerCase().includes(cursorFilterString?.toLocaleLowerCase())).map((cursor,index) =>(
                                        <div key={index} onClick={() => setSelectedCursor(cursor)}>
                                            {formatCursorForDisplay(cursor)}
                                        </div>
                                    ))}
                                </div>
                            </div>
                            <div className="border-radius-container">
                                <p>Border radius</p>
                                <div>
                                    <p>{borderRadius}%</p>
                                    <input
                                        type="range"
                                        min={0}
                                        max={100}
                                        step={1}
                                        value={borderRadius}
                                        onChange={(e) => setBorderRadius(Number(e.target.value))}
                                    />
                                </div>
                            </div>
                            <div className="mobile-height-container">
                                <p>Mobile height factor</p>
                                <div>
                                    <p>{mobileHeightFactor}</p>
                                    <input
                                        type="range"
                                        min={1}
                                        max={10}
                                        step={0.1}
                                        value={mobileHeightFactor}
                                        onChange={(e) => setMobileHeightFactor(Number(e.target.value))}
                                    />
                                </div>
                            </div>
                        </div>
                    </div>
            </div>
        </div>
    );
};
export default EditStateNavigationButtonWidget;